<main>
<!-- Mobil: Tam ekran misafir overlay -->
<div class="mobile-guest-overlay" *ngIf="isGuestSelectorOpen">
  <div class="mobile-guest-overlay__header">
    <button type="button" class="mobile-guest-overlay__back" (click)="toggleGuestSelector()">
      <i class="icon-arrow-left text-20"></i>
    </button>
    <span class="text-16 fw-600">Misafirler</span>
    <button type="button" class="mobile-guest-overlay__done" (click)="toggleGuestSelector()">Tamam</button>
  </div>
  <div class="mobile-guest-overlay__content">
    <!-- Oda ekle -->
    <div class="d-flex justify-end mb-20">
      <div role="button" tabindex="0" (click)="addRoom()"
        class="d-flex items-center x-gap-10 rounded-4"
        [ngStyle]="{ border: '1px dashed #2F80ED', color: '#2F80ED', padding: '8px 14px', cursor: searchForm.get('rooms')?.value >= 2 ? 'not-allowed' : 'pointer', opacity: searchForm.get('rooms')?.value >= 2 ? 0.5 : 1 }">
        <i class="icon-plus text-12"></i>
        <span class="text-14 fw-600">Oda ekle</span>
      </div>
    </div>

    <!-- Yetişkin -->
    <div class="d-flex justify-between items-center">
      <div class="text-15 fw-500">Yetişkin</div>
      <div class="d-flex items-center">
        <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
          (click)="updateGuestCount('adults', false)"><i class="icon-minus text-12"></i></button>
        <div class="flex-center size-20 ml-15 mr-15">
          <div class="text-15">{{ searchForm.get("adults")?.value }}</div>
        </div>
        <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
          (click)="updateGuestCount('adults', true)"><i class="icon-plus text-12"></i></button>
      </div>
    </div>

    <div class="border-top-light mt-24 mb-24"></div>

    <!-- Çocuk -->
    <div class="d-flex justify-between items-center">
      <div>
        <div class="text-15 lh-12 fw-500">Çocuk</div>
        <div class="text-14 lh-12 text-light-1 mt-5">0 - 17 yaş</div>
      </div>
      <div class="d-flex items-center">
        <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
          (click)="updateGuestCount('children', false)"><i class="icon-minus text-12"></i></button>
        <div class="flex-center size-20 ml-15 mr-15">
          <div class="text-15">{{ searchForm.get("children")?.value }}</div>
        </div>
        <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
          (click)="updateGuestCount('children', true)"><i class="icon-plus text-12"></i></button>
      </div>
    </div>

    <!-- Çocuk Yaşları -->
    <div *ngIf="searchForm.get('children')?.value > 0" class="mt-20">
      <div class="text-15 fw-500 mb-16">Çocuk Yaşları</div>
      <div class="children-ages-grid">
        <div *ngFor="let age of childrenAges; let i = index; trackBy: trackByIndex" class="d-flex flex-column items-center">
          <div class="text-12 fw-500 mb-8">{{ i + 1 }}. Çocuk</div>
          <select class="child-age-select" [ngModel]="childrenAges[i]" (ngModelChange)="updateChildAge(i, $event)">
            <option *ngFor="let a of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]" [ngValue]="a">{{ a }} yaş</option>
          </select>
        </div>
      </div>
    </div>

    <!-- 2. Oda -->
    <div *ngIf="searchForm.get('rooms')?.value === 2">
      <div class="border-top-light mt-24 mb-24"></div>
      <div class="d-flex items-center justify-between mb-10">
        <div class="text-15 fw-600">2. Oda</div>
        <a role="button" (click)="removeRoom()" class="text-13 fw-600" style="color: #EB5757;">
          <i class="icon-minus text-12 mr-5"></i>Kaldır
        </a>
      </div>
      <div class="d-flex justify-between items-center">
        <div class="text-15 fw-500">Yetişkin</div>
        <div class="d-flex items-center">
          <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
            (click)="updateGuestCountRoom2('room2Adults', false)"><i class="icon-minus text-12"></i></button>
          <div class="flex-center size-20 ml-15 mr-15">
            <div class="text-15">{{ searchForm.get('room2Adults')?.value }}</div>
          </div>
          <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
            (click)="updateGuestCountRoom2('room2Adults', true)"><i class="icon-plus text-12"></i></button>
        </div>
      </div>
      <div class="border-top-light mt-24 mb-24"></div>
      <div class="d-flex justify-between items-center">
        <div class="text-15 lh-12 fw-500">Çocuk</div>
        <div class="d-flex items-center">
          <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
            (click)="updateGuestCountRoom2('room2Children', false)"><i class="icon-minus text-12"></i></button>
          <div class="flex-center size-20 ml-15 mr-15">
            <div class="text-15">{{ searchForm.get('room2Children')?.value }}</div>
          </div>
          <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
            (click)="updateGuestCountRoom2('room2Children', true)"><i class="icon-plus text-12"></i></button>
        </div>
      </div>
      <div *ngIf="searchForm.get('room2Children')?.value > 0" class="mt-20">
        <div class="text-15 fw-500 mb-16">2. Oda Çocuk Yaşları</div>
        <div class="children-ages-grid">
          <div *ngFor="let age of room2ChildrenAges; let i = index; trackBy: trackByIndex" class="d-flex flex-column items-center">
            <div class="text-12 fw-500 mb-8">{{ i + 1 }}. Çocuk</div>
            <select class="child-age-select" [ngModel]="room2ChildrenAges[i]" (ngModelChange)="updateChildAgeRoom2(i, $event)">
              <option *ngFor="let a of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]" [ngValue]="a">{{ a }} yaş</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mobil: Tam ekran takvim overlay -->
<div class="mobile-calendar-overlay" *ngIf="isCalendarOpen">
  <div class="mobile-calendar-overlay__header">
    <button type="button" class="mobile-calendar-overlay__back" (click)="toggleCalendar()">
      <i class="icon-arrow-left text-20"></i>
    </button>
    <span class="text-16 fw-600" style="color: #3554d1;">Tarih Seçin</span>
    <button type="button" class="mobile-calendar-overlay__done" (click)="toggleCalendar()">Tamam</button>
  </div>

  <!-- Sekmeler -->
  <div class="mobile-calendar-tabs">
    <button type="button" [class.active]="mobileCalendarTab === 'calendar'" (click)="mobileCalendarTab = 'calendar'">Takvim</button>
    <button type="button" [class.active]="mobileCalendarTab === 'holidays'" (click)="mobileCalendarTab = 'holidays'">Özel Günler</button>
    <button type="button" [class.active]="mobileCalendarTab === 'weekends'" (click)="mobileCalendarTab = 'weekends'">Hafta Sonları</button>
  </div>

  <div class="mobile-calendar-overlay__content">
    <!-- TAKVİM SEKMESİ -->
    <div *ngIf="mobileCalendarTab === 'calendar'">
      <app-date-range-picker
        [startDate]="searchForm.get('checkInDate')?.value"
        [endDate]="searchForm.get('checkOutDate')?.value"
        [isOpen]="true"
        [staticMode]="true"
        (dateRangeSelected)="onDateRangeSelected($event)">
      </app-date-range-picker>
    </div>

    <!-- ÖZEL GÜNLER SEKMESİ -->
    <div *ngIf="mobileCalendarTab === 'holidays'">
      <div *ngFor="let h of holidays" class="mobile-calendar-item" (click)="selectHoliday(h)">
        <div class="mobile-calendar-item__icon">{{ h.icon }}</div>
        <div class="mobile-calendar-item__info">
          <div class="mobile-calendar-item__name">{{ h.name }}</div>
          <div class="mobile-calendar-item__dates">
            <ng-container *ngIf="h.singleDay">{{ h.start | date:'d MMMM yyyy' }}</ng-container>
            <ng-container *ngIf="!h.singleDay">{{ h.start | date:'d MMM' }} - {{ h.end | date:'d MMM yyyy' }}</ng-container>
            <span class="mobile-calendar-item__nights">{{ getNightCount(h.start, h.end) }} gece</span>
          </div>
        </div>
        <i class="icon-chevron-right text-14 text-light-1"></i>
      </div>
      <div *ngIf="holidays.length === 0" class="text-center py-30 text-light-1">
        Yaklaşan özel gün bulunmuyor.
      </div>
    </div>

    <!-- HAFTA SONLARI SEKMESİ -->
    <div *ngIf="mobileCalendarTab === 'weekends'">
      <div *ngFor="let w of upcomingWeekends" class="mobile-calendar-item" (click)="selectWeekend(w)">
        <div class="mobile-calendar-item__icon">📅</div>
        <div class="mobile-calendar-item__info">
          <div class="mobile-calendar-item__name">{{ w.label }}</div>
          <div class="mobile-calendar-item__dates"></div>
        </div>
        <i class="icon-chevron-right text-14 text-light-1"></i>
      </div>
    </div>
  </div>
</div>

<!-- Mobil: Tam ekran location overlay -->
<div class="mobile-location-overlay" *ngIf="isMobileLocationOpen">
  <div class="mobile-location-overlay__header">
    <button type="button" class="mobile-location-overlay__back" (click)="closeMobileLocation()">
      <i class="icon-arrow-left text-20"></i>
    </button>
    <input
      type="text"
      class="mobile-location-overlay__input"
      [placeholder]="typingPlaceholder || 'Şehir, bölge veya otel adı yazın'"
      [value]="mobileLocationSearch"
      (input)="onMobileLocationInput($any($event.target).value)"
      autocomplete="off" />
  </div>
  <div class="mobile-location-overlay__results">
    <!-- Arama sonuçları -->
    <ng-container *ngIf="mobileLocationSearch.length > 0">
      <div *ngFor="let location of filteredLocations$ | async"
        class="mobile-location-overlay__item"
        (click)="onLocationSelect(location)">
        <i class="icon-location text-16 text-blue-1 mr-10"></i>
        <span>{{ location.label }}</span>
      </div>
    </ng-container>

    <!-- Input boşken popüler öneriler -->
    <ng-container *ngIf="mobileLocationSearch.length === 0">
      <div class="mobile-location-overlay__section-title">Popüler Aramalar</div>
      <div *ngFor="let suggestion of quickSuggestions"
        class="mobile-location-overlay__item"
        (click)="onLocationSelect(suggestion)">
        <i class="icon-star text-16 text-blue-1 mr-10"></i>
        <span>{{ suggestion.label }}</span>
      </div>
    </ng-container>
  </div>
</div>
  <!-- Masthead Section -->
  <section data-anim-wrap class="masthead -type-5">
    <div data-anim-child="fade" class="masthead__bg">
      <img src="/assets/img/masthead/5/bg.svg" alt="image">
    </div>

    <div class="container">
      <div class="row justify-center text-center">
        <div class="col-xl-10 col-lg-11">

          <!-- Maximum Strip -->
          <div class="maximum-strip mb-15" data-anim-child="slide-up delay-3">
            <div class="maximum-strip__inner">
              <img src="assets/maximum@2x.png" alt="Maximum" class="maximum-strip__logo">
              <span class="maximum-strip__dot"></span>
              <span class="maximum-strip__text">Peşin Fiyatına <strong>9 Taksit</strong> İmkanı</span>
            </div>
          </div>

          <h1 data-anim-child="slide-up delay-4" class="text-60 lg:text-40 md:text-30 ">Senin Yolculuğun, Senin  <span
              class="text-blue-1 relative">Yolun ! <span class="-line"><img src="assets/img/general/line.png"
                  alt="image"></span></span></h1>
          <div data-anim-child="slide-up delay-6"
            class="mainSearch bg-white rounded-16 shadow-search-strong mt-35" style="text-align: left;">
            <form [formGroup]="searchForm" (ngSubmit)="performSearch()">
              <div class="search-grid">

                <!-- Location -->
                <div class="search-field" (click)="openMobileLocation(); $event.stopPropagation()">
                  <div class="search-field__icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  </div>
                  <div class="search-field__content">
                    <div class="search-field__label">Nereye?</div>
                    <input autocomplete="off" type="search" formControlName="location"
                      [placeholder]="typingPlaceholder || 'Şehir, bölge veya otel'" class="search-field__input desktop-location-input"
                      [matAutocomplete]="auto"
                      #autoTrigger="matAutocompleteTrigger"
                      (focus)="onLocationFocus()"
                      (blur)="onLocationBlur()" />
                    <mat-autocomplete #auto="matAutocomplete"
                      (optionSelected)="onLocationSelect($event.option.value)"
                      panelWidth="auto">
                      <mat-option *ngFor="let location of filteredLocations$ | async" [value]="location">
                        {{ location.label }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>

                <div class="search-divider"></div>

                <!-- Date -->
                <div class="search-field search-field--date">
                  <div class="search-field__trigger" (click)="toggleCalendar(); $event.stopPropagation()">
                    <div class="search-field__icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                    </div>
                    <div class="search-field__content">
                      <div class="search-field__label">Tarih</div>
                      <div class="search-field__value">
                        <ng-container *ngIf="searchForm.get('checkInDate')?.value && searchForm.get('checkOutDate')?.value">
                          {{ searchForm.get('checkInDate')?.value | date:'d MMM' }} → {{ searchForm.get('checkOutDate')?.value | date:'d MMM' }}
                        </ng-container>
                        <span *ngIf="!searchForm.get('checkInDate')?.value || !searchForm.get('checkOutDate')?.value" class="search-field__placeholder">Tarih seçin</span>
                      </div>
                    </div>
                  </div>
                  <div class="desktop-calendar-dropdown" (click)="$event.stopPropagation()">
                    <div class="desktop-calendar-panel" *ngIf="isCalendarOpen">
                      <!-- Sekmeler -->
                      <div class="desktop-calendar-tabs">
                        <button type="button" [class.active]="mobileCalendarTab === 'calendar'" (click)="mobileCalendarTab = 'calendar'">Takvim</button>
                        <button type="button" [class.active]="mobileCalendarTab === 'holidays'" (click)="mobileCalendarTab = 'holidays'">Özel Günler</button>
                        <button type="button" [class.active]="mobileCalendarTab === 'weekends'" (click)="mobileCalendarTab = 'weekends'">Hafta Sonları</button>
                      </div>

                      <!-- TAKVİM -->
                      <div *ngIf="mobileCalendarTab === 'calendar'" class="desktop-calendar-body">
                        <app-date-range-picker [startDate]="searchForm.get('checkInDate')?.value"
                          [endDate]="searchForm.get('checkOutDate')?.value" [isOpen]="true" [staticMode]="true"
                          (dateRangeSelected)="onDateRangeSelected($event)" (closed)="closeCalendar()">
                        </app-date-range-picker>
                      </div>

                      <!-- ÖZEL GÜNLER -->
                      <div *ngIf="mobileCalendarTab === 'holidays'" class="desktop-calendar-body desktop-calendar-list">
                        <div *ngFor="let h of holidays" class="desktop-calendar-item" (click)="selectHoliday(h)">
                          <span class="desktop-calendar-item__icon">{{ h.icon }}</span>
                          <div class="desktop-calendar-item__info">
                            <div class="desktop-calendar-item__name">{{ h.name }}</div>
                            <div class="desktop-calendar-item__dates">
                              <ng-container *ngIf="h.singleDay">{{ h.start | date:'d MMMM yyyy' }}</ng-container>
                              <ng-container *ngIf="!h.singleDay">{{ h.start | date:'d MMM' }} - {{ h.end | date:'d MMM' }}</ng-container>
                              <span class="nights-badge">{{ getNightCount(h.start, h.end) }} gece</span>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="holidays.length === 0" class="text-center py-20 text-light-1 text-14">Yaklaşan özel gün yok.</div>
                      </div>

                      <!-- HAFTA SONLARI -->
                      <div *ngIf="mobileCalendarTab === 'weekends'" class="desktop-calendar-body desktop-calendar-list">
                        <div *ngFor="let w of upcomingWeekends" class="desktop-calendar-item" (click)="selectWeekend(w)">
                          <span class="desktop-calendar-item__icon">📅</span>
                          <div class="desktop-calendar-item__info">
                            <div class="desktop-calendar-item__name">{{ w.label }}</div>
                            <div class="desktop-calendar-item__dates"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="search-divider"></div>

                <!-- Guests -->
                <div class="search-field search-field--guests">
                  <div class="search-field__trigger" (click)="toggleGuestSelector(); $event.stopPropagation()">
                    <div class="search-field__icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                    </div>
                    <div class="search-field__content">
                      <div class="search-field__label">Misafir</div>
                      <div class="search-field__value">
                        {{ getTotalAdults() }} yetişkin · {{ getTotalChildren() }} çocuk · {{ searchForm.get("rooms")?.value }} oda
                      </div>
                    </div>
                  </div>
                  <div (click)="$event.stopPropagation()">
                    <div class="searchMenu-guests__field shadow-2" [class.-is-active]="isGuestSelectorOpen">
                    <div class="bg-white px-30 py-30 rounded-4">
                      <!-- Add Room Button -->
                      <div class="d-flex justify-between items-center mb-20">
                        <div class="text-15 fw-600">Misafirler</div>
                        <div role="button" tabindex="0" (click)="addRoom()"
                          class="d-flex items-center x-gap-10 rounded-4"
                          [ngStyle]="{ border: '1px dashed #2F80ED', color: '#2F80ED', padding: '8px 14px', cursor: searchForm.get('rooms')?.value >= 2 ? 'not-allowed' : 'pointer', opacity: searchForm.get('rooms')?.value >= 2 ? 0.5 : 1 }">
                          <i class="icon-plus text-12"></i>
                          <span class="text-14 fw-600">Oda ekle</span>
                        </div>
                      </div>

                      <!-- Adults -->
                      <div class="row y-gap-10 justify-between items-center">
                        <div class="col-auto">
                          <div class="text-15 fw-500">Yetişkin</div>
                        </div>
                        <div class="col-auto">
                          <div class="d-flex items-center">
                            <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                              (click)="updateGuestCount('adults', false)">
                              <i class="icon-minus text-12"></i>
                            </button>
                            <div class="flex-center size-20 ml-15 mr-15">
                              <div class="text-15">{{ searchForm.get("adults")?.value }}</div>
                            </div>
                            <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                              (click)="updateGuestCount('adults', true)">
                              <i class="icon-plus text-12"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="border-top-light mt-24 mb-24"></div>

                      <!-- Children -->
                      <div class="row y-gap-10 justify-between items-center">
                        <div class="col-auto">
                          <div class="text-15 lh-12 fw-500">Çocuk</div>
                          <div class="text-14 lh-12 text-light-1 mt-5">0 - 17 yaş</div>
                        </div>
                        <div class="col-auto">
                          <div class="d-flex items-center">
                            <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                              (click)="updateGuestCount('children', false)">
                              <i class="icon-minus text-12"></i>
                            </button>
                            <div class="flex-center size-20 ml-15 mr-15">
                              <div class="text-15">{{ searchForm.get("children")?.value }}</div>
                            </div>
                            <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                              (click)="updateGuestCount('children', true)">
                              <i class="icon-plus text-12"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- Children Ages -->
                      <div *ngIf="searchForm.get('children')?.value > 0" class="mt-20">
                        <div class="text-15 fw-500 mb-16">Çocuk Yaşları</div>
                        <div class="children-ages-grid">
                          <div *ngFor="let age of childrenAges; let i = index; trackBy: trackByIndex" class="d-flex flex-column items-center">
                            <div class="text-12 fw-500 mb-8">{{ i + 1 }}. Çocuk</div>
                            <select class="child-age-select" [ngModel]="childrenAges[i]" (ngModelChange)="updateChildAge(i, $event)">
                              <option *ngFor="let a of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]" [ngValue]="a">{{ a }} yaş</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <!-- Room 2 -->
                      <div *ngIf="searchForm.get('rooms')?.value === 2">
                        <div class="border-top-light mt-24 mb-24"></div>
                        <div class="d-flex items-center justify-between mb-10">
                          <div class="text-15 fw-600">2. Oda</div>
                          <a role="button" (click)="removeRoom()" class="text-13 fw-600" style="color: #EB5757;">
                            <i class="icon-minus text-12 mr-5"></i>Kaldır
                          </a>
                        </div>

                        <div class="row y-gap-10 justify-between items-center">
                          <div class="col-auto">
                            <div class="text-15 fw-500">Yetişkin</div>
                          </div>
                          <div class="col-auto">
                            <div class="d-flex items-center">
                              <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                                (click)="updateGuestCountRoom2('room2Adults', false)"><i
                                  class="icon-minus text-12"></i></button>
                              <div class="flex-center size-20 ml-15 mr-15">
                                <div class="text-15">{{ searchForm.get('room2Adults')?.value }}</div>
                              </div>
                              <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                                (click)="updateGuestCountRoom2('room2Adults', true)"><i
                                  class="icon-plus text-12"></i></button>
                            </div>
                          </div>
                        </div>

                        <div class="border-top-light mt-24 mb-24"></div>

                        <div class="row y-gap-10 justify-between items-center">
                          <div class="col-auto">
                            <div class="text-15 lh-12 fw-500">Çocuk</div>
                          </div>
                          <div class="col-auto">
                            <div class="d-flex items-center">
                              <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                                (click)="updateGuestCountRoom2('room2Children', false)"><i
                                  class="icon-minus text-12"></i></button>
                              <div class="flex-center size-20 ml-15 mr-15">
                                <div class="text-15">{{ searchForm.get('room2Children')?.value }}</div>
                              </div>
                              <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                                (click)="updateGuestCountRoom2('room2Children', true)"><i
                                  class="icon-plus text-12"></i></button>
                            </div>
                          </div>
                        </div>

                        <div *ngIf="searchForm.get('room2Children')?.value > 0" class="mt-20">
                          <div class="text-15 fw-500 mb-16">2. Oda Çocuk Yaşları</div>
                          <div class="children-ages-grid">
                            <div *ngFor="let age of room2ChildrenAges; let i = index; trackBy: trackByIndex"
                              class="d-flex flex-column items-center">
                              <div class="text-12 fw-500 mb-8">{{ i + 1 }}. Çocuk</div>
                              <select class="child-age-select" [ngModel]="room2ChildrenAges[i]"
                                (ngModelChange)="updateChildAgeRoom2(i, $event)">
                                <option *ngFor="let a of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]" [ngValue]="a">{{ a }} yaş</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>

                <!-- Search Button -->
                <div class="search-btn-wrap">
                  <button type="submit" class="search-btn" [disabled]="loading">
                    <svg *ngIf="!loading" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                    <span>{{ loading ? 'Aranıyor...' : '' }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>

        </div>

      </div>
    </div>

  </section>

  <!-- Hızlı Otel Kategorileri (Mavi alanın altında) -->
  <section class="quick-pills-section">
    <div class="container">
      <div class="quick-pills">
        <span class="quick-pills__label">Popüler Aramalar</span>
        <div class="quick-pills__scroll">
          <button *ngFor="let item of hotelQuickLinks"
                  type="button"
                  class="quick-pill"
                  (click)="searchByQuickLink(item)">
            {{ item.label }}
            <i class="icon-chevron-right text-9 ml-5"></i>
          </button>
        </div>
      </div>
    </div>
  </section>


  <!-- Popular Destinations Section -->
  <section class="popular-section">
    <div class="container">
      <div class="popular-header popular-header--with-pusuli">
        <img src="assets/pusula/pusli.png" alt="Pusuli" class="popular-header__pusuli">
        <div class="popular-header__text">
          <h2 class="popular-header__title">Pusuli ile Tatil Rotanı Seç</h2>
          <p class="popular-header__desc">Popüler destinasyonlar — en çok tercih edilen tatil noktaları</p>
        </div>
      </div>

      <!-- Desktop: Bento Grid -->
      <div class="popular-bento" *ngIf="popularItems.length > 0">
        <!-- Sol: Promo Slider (büyük) -->
        <div class="popular-bento__promo">
          <div class="promo-slide" [class.promo-slide--visible]="activePromoSlide === 0">
            <img src="assets/img/promo/maximum-kibris.jpg" alt="Maximum Kıbrıs 3 Taksit" class="promo-slide__bg">
          </div>
          <div class="promo-slide" [class.promo-slide--visible]="activePromoSlide === 1">
            <img src="assets/img/promo/tur-hediye.jpg" alt="Tur Hediye" class="promo-slide__bg">
          </div>
          <div class="promo-dots">
            <span class="promo-dot" [class.promo-dot--active]="activePromoSlide === 0"></span>
            <span class="promo-dot" [class.promo-dot--active]="activePromoSlide === 1"></span>
          </div>
        </div>

        <!-- Sağ: 4 popüler öğe (dönen) -->
        <a *ngFor="let item of getVisiblePopularItems(); let i = index"
          (click)="searchByPopularItem(item)"
          class="popular-bento__card"
          [class.disabled]="loading">
          <img [src]="getPopularItemImage(item)" [alt]="item.label" class="popular-bento__img" loading="lazy">
          <div class="popular-bento__overlay">
            <h4 class="popular-bento__name">{{ item.label }}</h4>
            <span class="popular-bento__cta">Keşfet <i class="icon-arrow-top-right text-11 ml-5"></i></span>
          </div>
        </a>
      </div>

      <!-- Mobil: Carousel (popüler + promo karışık) -->
      <div class="popular-carousel" *ngIf="popularItems.length > 0">
        <div class="popular-track" #popularTrack>
          <ng-container *ngFor="let slide of mobileCarouselSlides; let i = index">
            <!-- Popüler öğe kartı -->
            <a *ngIf="slide.type === 'destination'"
              (click)="onPopularCardClick(slide.item, i)"
              class="popular-card"
              [ngClass]="getPopularCardClass(i)"
              [class.disabled]="loading">
              <img [src]="getPopularItemImage(slide.item)" [alt]="slide.item.label" class="popular-card__img" loading="lazy">
              <div class="popular-card__overlay">
                <h4 class="popular-card__name">{{ slide.item.label }}</h4>
              </div>
            </a>
            <!-- Promo kartı -->
            <div *ngIf="slide.type === 'promo'"
              class="popular-card popular-card--promo"
              [ngClass]="getPopularCardClass(i)">
              <img *ngIf="slide.promoId === 'maximum'" src="assets/img/promo/maximum-kibris-mobile.jpg" alt="Maximum Kıbrıs 3 Taksit" class="popular-card__img">
              <img *ngIf="slide.promoId === 'tour'" src="assets/img/promo/tur-hediye-mobile.jpg" alt="Tur Hediye" class="popular-card__img">
            </div>
          </ng-container>
        </div>

        <div class="popular-dots">
          <button *ngFor="let slide of mobileCarouselSlides; let i = index"
            class="popular-dot"
            [class.popular-dot--active]="i === activePopularIndex"
            (click)="goToPopular(i)"></button>
        </div>
      </div>
    </div>
  </section>

  <!-- Loading -->

  <!-- Error -->
  <div *ngIf="error" class="container">
    <div class="alert alert-danger mt-20" role="alert">{{ error }}</div>
  </div>


<app-features></app-features>
  <app-newsletter></app-newsletter>
</main>